import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';

import './Checkbox.scss';

class Checkbox extends Component {
	constructor(props) {
		super(props);
		this.state= {
			checked: (this.props.checked === true)
		}
		this.handleClick = this.handleClick.bind(this);
		this.handleChange = this.handleChange.bind(this);
	
	}
	
	handleChange(e) {
		const v = !this.state.checked;
		this.setState({checked: v});
		this.props.onChange({
			target: {
				type: 'checkbox',
				checked: v,
				name: this.props.name
			}
		});
		e.preventDefault();
		e.stopPropagation();
	}
	
	handleClick(e) {
		this.handleChange(e);
		e.preventDefault();
		e.stopPropagation();
	}
	
	
	
	render() {
		return <div className="Checkbox" onClick={this.handleClick}>
			<input type="checkbox" name={this.props.name} checked={this.state.checked} id={this.props.id} onChange={this.handleChange} />
			<FontAwesomeIcon icon={this.state.checked ? faCheckSquare : faSquare} />
		</div>;
	}
}

export default Checkbox;
